<template>
  <el-card v-loading="loading">
    <div ref="scrollContainer" id="page-panel" >
      <!-- <resize-observer @notify="__resizeHanlder" /> -->

        <div class="customer-top-nav">
          <div class="title">
            <span>{{$t('reports.names.'+reportCode)}}</span><br>
          </div>
          <div class="controls no-print">
             <!-- <el-button @click="print" size="small"><i class="mdi mdi-printer"></i> Télécharger</el-button> -->
             <el-dropdown size="small" type="default" class="">
               <el-button type="primary" size="small">
                 <i class="el-icon-download"></i>
               </el-button>
               <el-dropdown-menu slot="dropdown">
                 <el-dropdown-item @click.native="downloadReport('pdf')"><i class="mdi mdi-file-pdf"/> Commission à payer (PDF)</el-dropdown-item>
               </el-dropdown-menu>
             </el-dropdown>
    				 
    			</div>
        </div>

        <div>
          <el-form :model="filters" label-width="120px">
            <el-form-item label="Représentant">
              <el-select v-model="filters.repId" size="small" placeholder="Représentant">
                <el-option v-for="rep in filterUserWithRoleRep" :key="rep.id" :label="rep.firstName + ' ' + rep.lastName" :value="rep.id"></el-option>
              </el-select>
            </el-form-item>
             <el-form-item label="Mois">
                  <el-date-picker
                    v-model="selectedDate"
                    type="month"
                    :picker-options="datePickerOptions"
                    placeholder="Sélectionnez un mois">
                  </el-date-picker>
            </el-form-item>
            <el-button :disabled="!searchPossible" type="primary" size="small" @click="fetchData">Afficher</el-button>
          </el-form>
        <el-divider/>
        <el-row v-if="dataFetched" :gutter="20">
           <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <InfoStatsCard  :text="$t('reports.commission_selected')" v-bind:total="formatAmount(totalSelectedCommission)" v-bind:sign="''" v-bind:icon="'mdi-cash-refund'"  v-bind:status="'success'" ></InfoStatsCard>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <InfoStatsCard  :text="$t('reports.commission_calculated')" v-bind:total="formatAmount(totalCalculatedCommission)" v-bind:sign="''" v-bind:icon="'mdi-cash'"  v-bind:status="'success'" ></InfoStatsCard>
          </el-col>
        </el-row>
        <el-collapse v-model="activeTabs">
          <el-collapse-item name="1">
            <template slot="title">
              <span v-if="totalPreviousPeriods > 0" class="danger-text">Périodes précédentes ({{this.totalPreviousPeriods}})</span>
              <span v-else>Périodes précédentes (0)</span>
            </template>
            <el-button class="m-5" size="small" type="primary" v-loading="selectAllPreviousLoading" :disabled="!dataFetched" plain @click="selectAllPrevious">Sélectionner tout</el-button>
            <el-table :data="unselectedCommissionPreviousPeriod" :style="tableWidth" stripe empty-text="Il n'y a aucune transaction adminissible pour cette période." border>
              <el-table-column  width="55">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.selected" @change="v => handleSelection(scope.row, v)"></el-checkbox>
                </template> 
              </el-table-column>
              <el-table-column   label="Client" prop="meta.customerName" width="130" sortable>
                <template slot-scope="scope">
                  <span class="fs-12"><PortausLink fs="fs-12" :id="scope.row.meta.customerId" path="/customers/" :label="scope.row.meta.customerName"></PortausLink></span>
                </template>
              </el-table-column>
              <el-table-column   label="Facture" prop="invoiceNumber" width="130" sortable>
                <template slot-scope="scope">
                  <span class="fs-12"><PortausLink fs="fs-12" :id="scope.row.invoice.id" path="/invoices/" :label="scope.row.meta.invNumber"></PortausLink></span>
                </template>
              </el-table-column>
              <el-table-column   label="Date" prop="date" width="100" sortable>
                <template slot-scope="scope">
                  <span class="fs-12">{{formatDate(scope.row.date)}}</span>
                </template>
              </el-table-column>
              <el-table-column   label="Produit" prop="meta.product" width="300" sortable :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span class="fs-12">{{scope.row.meta.product}}</span>
                </template>
              </el-table-column>
               <el-table-column   label="Commentaires" prop="commentaries" width="200" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span class="fs-12">{{scope.row.commentaries}}</span>
                </template>
              </el-table-column>
              <el-table-column   label="Qty" prop="meta.qty" sortable :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span class="fs-12">{{scope.row.meta.qty}}</span>
                </template>
              </el-table-column>
              <el-table-column   label="Frais" prop="meta.price" sortable :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span class="fs-12">{{formatAmount(scope.row.meta.price)}}</span>
                </template>
              </el-table-column>
              <el-table-column   label="Rabais" prop="meta.calculatedCommission.rebateAmount" sortable :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span class="fs-12" v-if="scope.row.meta.calculatedCommission.rebateAmount">{{formatAmount(scope.row.meta.calculatedCommission.rebateAmount)}}</span>
                  <span v-else> -- </span>
                </template>
              </el-table-column>
              <el-table-column label="Montant admissible" prop="meta.calculatedCommission.subTotalAdmissible" sortable :show-overflow-tooltip="true" width="120">
                <template slot-scope="scope">
                  <span class="fs-12">{{formatAmount(scope.row.meta.calculatedCommission.subTotalAdmissible)}}</span>
                </template>
              </el-table-column>
              <el-table-column   label="% Comm." :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span class="fs-12" v-if="scope.row.meta.calculatedCommission.fixedAmount == null">{{scope.row.meta.calculatedCommission.defaultPercentage * 100}} %</span>
                    <span class="fs-12" v-else> -- </span>
                </template>
              </el-table-column>
              <el-table-column   label="$ Comm./b" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <div  v-if="scope.row.meta.calculatedCommission.fixedAmount != null">
                      <span class="fs-12" v-if="scope.row.meta.calculatedCommission.ajustedFixedAmount == null">{{formatAmount(scope.row.meta.calculatedCommission.fixedAmount)}}</span>
                      <span v-else>
                        <span class="fs-12" style="text-decoration: line-through;">{{formatAmount(scope.row.meta.calculatedCommission.fixedAmount)}}</span>
                        <span class="fs-12 ml-10" >{{formatAmount(scope.row.meta.calculatedCommission.ajustedFixedAmount)}}</span>
                      </span>
                    </div>
                    <span class="fs-12" v-else> -- </span>
                </template>
              </el-table-column>
              <el-table-column   label="Total" prop="amount" :show-overflow-tooltip="true" sortable>
                <template slot-scope="scope">
                    <span class="fs-12">{{formatAmount(scope.row.amount)}}</span>
                </template>
              </el-table-column>
              <el-table-column   label="">
                <template slot-scope="scope">
                  
                </template>
              </el-table-column>
            </el-table>
          </el-collapse-item>
       
         <el-collapse-item name="2">
          <template slot="title">
              Période courante ({{this.totalCurrentPeriod}})
            </template>
            <el-button class="m-5" size="small" type="primary" v-loading="selectAllLoading" :disabled="!dataFetched" plain @click="selectAll">Sélectionner tout</el-button>
            <el-table :data="selectedPeriodCommission" :style="tableWidth" stripe empty-text="Il n'y a aucune transaction adminissible pour cette période." border>
          <el-table-column  width="55">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.selected" @change="v => handleSelection(scope.row, v)"></el-checkbox>
            </template> 
          </el-table-column>
           <el-table-column   label="Client" prop="meta.customerName" width="130" sortable>
            <template slot-scope="scope">
              <span class="fs-12"><PortausLink fs="fs-12" :id="scope.row.meta.customerId" path="/customers/" :label="scope.row.meta.customerName"></PortausLink></span>
            </template>
          </el-table-column>
          <el-table-column   label="Facture" prop="invoiceNumber" width="130" sortable>
            <template slot-scope="scope">
              <span class="fs-12"><PortausLink fs="fs-12" :id="scope.row.invoice.id" path="/invoices/" :label="scope.row.meta.invNumber"></PortausLink></span>
            </template>
          </el-table-column>
          <el-table-column   label="Date" prop="date" width="100" sortable>
            <template slot-scope="scope">
              <span class="fs-12">{{formatDate(scope.row.date)}}</span>
            </template>
          </el-table-column>
          <el-table-column   label="Produit" prop="meta.product" width="300" sortable :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span class="fs-12">{{scope.row.meta.product}}</span>
            </template>
          </el-table-column>
           <el-table-column   label="Commentaires" width="200" prop="commentaries" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span class="fs-12">{{scope.row.commentaries}}</span>
              </template>
            </el-table-column>
           <el-table-column   label="Qty" prop="meta.qty" sortable :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span class="fs-12">{{scope.row.meta.qty}}</span>
            </template>
          </el-table-column>
           <el-table-column   label="Frais" prop="meta.price" sortable :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span class="fs-12">{{formatAmount(scope.row.meta.price)}}</span>
            </template>
          </el-table-column>
          <el-table-column   label="Rabais" prop="meta.calculatedCommission.rebateAmount" sortable :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span class="fs-12" v-if="scope.row.meta.calculatedCommission.rebateAmount">{{formatAmount(scope.row.meta.calculatedCommission.rebateAmount)}}</span>
              <span v-else> -- </span>
            </template>
          </el-table-column>
          <el-table-column label="Montant admissible" prop="meta.calculatedCommission.subTotalAdmissible" sortable :show-overflow-tooltip="true" width="120">
            <template slot-scope="scope">
              <span class="fs-12" v-if="scope.row.meta.calculatedCommission.subTotalAdmissible != null">{{formatAmount(scope.row.meta.calculatedCommission.subTotalAdmissible)}}</span>
              <span class="fs-12" v-else> -- </span>
            </template>
          </el-table-column>
          <el-table-column   label="% Comm." :show-overflow-tooltip="true">
            <template slot-scope="scope">
                <span class="fs-12" v-if="scope.row.meta.calculatedCommission.defaultPercentage != null && scope.row.meta.calculatedCommission.fixedAmount == null">{{scope.row.meta.calculatedCommission.defaultPercentage * 100}} %</span>
                <span class="fs-12" v-else> -- </span>
            </template>
          </el-table-column>
           <el-table-column   label="$ Comm./b" :show-overflow-tooltip="true">
            <template slot-scope="scope">
                <div  v-if="scope.row.meta.calculatedCommission.fixedAmount != null">
                  <span class="fs-12" v-if="scope.row.meta.calculatedCommission.ajustedFixedAmount == null">{{formatAmount(scope.row.meta.calculatedCommission.fixedAmount)}}</span>
                  <span v-else>
                    <span class="fs-12" style="text-decoration: line-through;">{{formatAmount(scope.row.meta.calculatedCommission.fixedAmount)}}</span>
                    <span class="fs-12 ml-10" >{{formatAmount(scope.row.meta.calculatedCommission.ajustedFixedAmount)}}</span>
                  </span>
                </div>
                <span class="fs-12" v-else> -- </span>
            </template>
          </el-table-column>
           <el-table-column   label="Total" prop="amount" :show-overflow-tooltip="true" sortable>
            <template slot-scope="scope">
                 <span class="fs-12">{{formatAmount(scope.row.amount)}}</span>
            </template>
          </el-table-column>
          <el-table-column   label="">
            <template slot-scope="scope">
              
            </template>
          </el-table-column>
            </el-table>
           </el-collapse-item>
           </el-collapse>
      </div>
    </div>
  </el-card>
</template>
<script>
//import Section
import commissionsAPI from '@/services/API/commission.js'

import moment from 'moment'
import dayjs from 'dayjs'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
dayjs.extend(isSameOrAfter)
import reportUtil from '@/utils/report-util.js'
import PortausLink from '@/components/portaus-link'
import PortausUtil from '@/utils/portaus-utils'
import { mapActions, mapState, mapGetters } from 'vuex';
import InfoStatsCard from '@/components/Info-stat-card'

export default {
  name : "report-commission",
  props : {
    width : {
      type : Number,
      default : 100
    },

  },
  data() {
    return {
      data : [],
      loading: false,
      selectAllLoading: false,
      selectAllPreviousLoading: false,
      dataFetched: false,
      selectedDate: null,
      activeTabs: '2',
      downloading: false,
      datePickerOptions: {
          disabledDate :this.disabledDateBeforeDate
      },
      filters : {
        repId : null,
        date : null,
      },
      pageWidth : null,
      pageHeight : null,
    };
  },
  components : {
    PortausLink,
    InfoStatsCard
  },
  computed : {
    totalSelectedCommission () {
      let total = 0;
      _.forEach(this.data, row => {
        if (row.selected) {
          total += row.amount || 0;
        }
        
      });
      return total;
    },
    totalCalculatedCommission () {
      let total = 0;
      _.forEach(this.data, row => {
        total += row.amount || 0;
      });
      return total;
    },
    reportCode(){
      return this.$route.params.code;
    },
    searchPossible() {
      return this.filters.repId != null && this.filters.date != null;
    },
    totalRecords() {
			return this.data.length
		},
    
    tableWidth(){
      return 'width : ' + this.width + 'px;';
    },
    selectedPeriodCommission(){
      return _.filter(this.data, d => dayjs(d.date).isSameOrAfter(this.filters.date));
    },
    unselectedCommissionPreviousPeriod(){
      return _.filter(this.data, d => dayjs(d.date).isBefore(dayjs(this.filters.date)));
    },
    totalCurrentPeriod(){
      return _.size(this.selectedPeriodCommission);
    },
    totalPreviousPeriods(){
      return _.size(this.unselectedCommissionPreviousPeriod);
    },
    ...mapState('controlData',['paymentTypeCategories']),
    ...mapGetters('users',['filterUserWithRoleRep', 'getUserById']),
  },
  methods : {
    selectAll () {
      // Le back-end bascule (toggle) chaque commission passée : on ne lui envoie donc que les non-sélectionnées.
      const selectedIds = this.selectedPeriodCommission
        .filter(d => d.selected !== true)
        .map(d => d.id);
      if (selectedIds.length === 0) {
        return;
      }
      this.selectAllLoading = true;
      return commissionsAPI.selectCommissions(selectedIds, dayjs(this.filters.date).format('YYYY-MM'))
        .then(() => {
          this.fetchData();
          this.selectAllLoading = false;
        }).catch(err => {
          this.$message.error('Une erreur est survenue lors de la sélection des commissions');
          this.selectAllLoading = false;
        })
    },
    selectAllPrevious () {
      // Même stratégie que selectAll : on n'envoie que les non-sélectionnées pour éviter les toggles indésirables.
      const selectedIds = this.unselectedCommissionPreviousPeriod
        .filter(d => d.selected !== true)
        .map(d => d.id);
      if (selectedIds.length === 0) {
        return;
      }
      this.selectAllPreviousLoading = true;
      return commissionsAPI.selectCommissions(selectedIds, dayjs(this.filters.date).format('YYYY-MM'))
        .then(() => {
          this.fetchData();
          this.selectAllPreviousLoading = false;
        }).catch(err => {
          this.$message.error('Une erreur est survenue lors de la sélection des commissions');
          this.selectAllPreviousLoading = false;
        })
    },
    handleSelection (commission, v) {
      return commissionsAPI.selectCommission(commission.id, dayjs(this.filters.date).format('YYYY-MM'));
    },
    formatDate (date, format = 'YYYY-MM-DD') {
      return dayjs(date).format(format);
    },
    disabledDateBeforeDate (date) {
        return  date < new Date('2025-09-01');
    },
    downloadReport(format){
      this.downloading=true;
      const params = this.buildParams();
      params.selectedPeriod = true;
      params.unselected = undefined;
      const rep = _.find(this.filterUserWithRoleRep, rep => rep.id === this.filters.repId);
      const date = dayjs(this.selectedDate).startOf('month').format('YYYY-MM')
      const filename = `commission-${date}-${rep.firstName} ${rep.lastName}.pdf`;
      return commissionsAPI.downloadReport(filename, params);
    },
    buildParams (){
      const filters = {
        repId: this.filters.repId,
        unselected: true,
        startDate: this.selectedDate ? dayjs(this.selectedDate).startOf('month').format('YYYY-MM-DD Z') : null,
        endDate: this.selectedDate ? dayjs(this.selectedDate).endOf('month').add(1, 'day').format('YYYY-MM-DD Z') : null,
      }
      return filters;
    },
		setPageWidth() {
			this.pageWidth = document.getElementById('page-panel').offsetWidth;
			this.pageHeight = document.getElementById('page-panel').offsetHeight;
		},
    __resizeHanlder: _.throttle(function (e) {
  			this.setPageWidth();
  		}, 700),
    fetchData(format = null){
      this.loading = true;
      const params = this.buildParams();

      this.filters.date = dayjs(this.selectedDate).startOf('month');

      return commissionsAPI.fetchCommissions(params)
        .then(data=>{
          this.dataFetched = true;
          this.data = data;
          this.loading = false;
          if (this.totalPreviousPeriods > 0) {
            this.activeTabs = ['1', '2'];
          } else {
            this.activeTabs = '2';
          }
        }).catch(err=>{
          this.loading = false;
          this.$message.error('Une erreur système est survenue. Veuillez réessayer plus tard')
        })
    },
    setFilters(){
      
    },
    formatAmount(amount) {
      return PortausUtil.formatAmount(amount, this.$i18n.locale);
    },
    ...mapActions('controlData',['fetchPaymentTypeCategories']),
     ...mapActions('users', ['fetchAdminUsers']),
  },
  mounted(){
    this.fetchAdminUsers();
    this.setPageWidth();
  },
  created(){
    this.filters.date = dayjs().subtract(1, 'month').startOf('month').toDate()
  },
  beforeDestroy(){
    this.data = [];
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../../assets/scss/_variables';

@media print {
  body, html { margin-top:0%;
    font-size:0.8em;
     display:block;
     height:100%;
     width:100%;
     position:unset !important;
     background:none;
     overflow-x: hidden;overflow-y: auto;height:100%;width:100%;display:block;position:unset
   }
   .no-print{
   	display:none;
   }
   .el-card{
     border:none;
     width:100%;
   }

   @page {
     size: portrait;
   }


}



.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:40px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}


</style>
